import { ACTION } from "Boards/ControlRow/constants";

import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";

export const getReportsList = async () => {
  const endpoint = `/board/reports`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getReportsList)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getReportBoard = async ({ boardID }) => {
  const endpoint = "/board/getReportBoard";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getReportBoard)
    : new FnrFetch3(endpoint, { boardID });

  const response = await fetchFunction.post().catch((err) => fnThrowError(err));

  return response;
};

export const createReportBoard = async ({
  title,
  groupIDs,
  filters,
  isShared,
  duplicateBoardID,
}) => {
  const endpoint = `/board/reports/board`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.createReportBoard)
    : new FnrFetch3(endpoint, {
        title,
        groupIDs,
        filters,
        isShared,
        duplicateBoardID,
      });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const updateReportBoard = async ({ groupName, boardName }) => {
  const endpoint = `/board/reports/board`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.updateReportBoard)
    : new FnrFetch3(endpoint, { groupName, boardName });

  const response = await fetchFunction.put().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getAvailableGroups = async ({ boardID }) => {
  const endpoint = `/board/getAvailableGroupsForLinking`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getAvailableGroups)
    : new FnrFetch3(endpoint, {
        boardID: 0,
        boardAction: ACTION.SAVE_AS_REPORT,
      });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const saveDefaultFilter = async ({ boardID, filters }) => {
  const endpoint = `/board/saveDefaultFilter`;
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.saveDefaultFilter)
    : new FnrFetch3(endpoint, { boardID, filters });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getReportTemplates = async () => {
  const endpoint = "/board/reports/templates";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getReportTemplates)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const duplicateReport = async ({
  sourceBoardID,
  title,
  groupIDs,
  copyData,
  makeReport,
  share,
}) => {
  const endpoint = "board/duplicateBoard";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.duplicateBoard)
    : new FnrFetch3(endpoint, {
        sourceBoardID,
        title,
        groupIDs,
        copyData,
        makeReport,
        share,
      });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};
